<ng-container *ngIf="board">

  <div class="root">
    <div class="project-top">
      <div class="project-header">

        <a (click)="router.navigateByUrl('/cabinet/crm/project')" style="margin: 0">
          <nb-icon status="basic" style="width: 30px; height: 30px" icon="arrow-ios-back-outline"></nb-icon>
        </a>
        <img [src]="getProjectImageUri(board.picture)" *ngIf="board.picture" alt="">
        <div class="project-name">{{ board.header }}</div>

        <a (click)="toggleProjectFavorites()">
          <nb-icon status="basic" *ngIf="!board.favorite" [ngbTooltip]="'Добавить в избранное'" icon="star-outline"></nb-icon>
          <nb-icon status="basic" *ngIf="board.favorite" [ngbTooltip]="'Удалить из избранного'" icon="star"></nb-icon>
        </a>

        <a [routerLink]="['/cabinet/crm/project/show/', projectId, 'add-column' ]" class="hide-for-client-role" [ngbTooltip]="'Добавить колонку'">
          <nb-icon status="basic" icon="folder-outline"></nb-icon>
        </a>

        <a [routerLink]="['/cabinet/crm/project/edit/', projectId]" class="hide-for-client-role" [ngbTooltip]="'Изменить проект'">
          <nb-icon status="basic" icon="edit-outline"></nb-icon>
        </a>

        <button nbButton size="small" [routerLink]="['/cabinet/crm/project/show/', projectId, 'add-issue' ]">Добавить задачу</button>
      </div>
      <div class="row">
        <div class="col-12">
          <div
          tuiGroup
          class="group"
          [collapsed]="true"
        >
          <a
            appearance="destructive"
            tuiButton
            type="button"
            size="xs"

          >
            Доска
          </a>
          <a

            appearance="outline"
            tuiButton
            type="button"
            size="xs"
            href="/cabinet/crm/project/gantt/{{this.board.id}}"
          >
            Гантт
          </a>

        </div></div>
      </div>

      <app-filter-issue [board]="board" [projectId]="projectId"></app-filter-issue>
    </div>


    <div class="board">
      <div class="board-wrapper">
        <div class="board-columns-wrap">

          <div #deskBoard cdkDropList
               cdkDropListOrientation="horizontal" class="board-columns"
               (cdkDropListDropped)="dropGrid($event)">
            <div
              cdkDragLockAxis="x" class="board-column"
              *ngFor="let column of board.columns" cdkDrag>
                <div class="column-title" cdkDragHandle>
                    <div class="column-title__text">
                        <input #input [attr.disabled]="column.columnType ? '' : null" type="text" nbInput
                               [(ngModel)]="column.header" [value]="column.header"
                               (blur)="updateHeader(column)" *ngIf="!column.headerDisabled"
                               (keyup.enter)="input.blur()"
                               contenteditable="true"
                               [status]="!column.header ? 'danger' : ''"
                               class="title-input">

                        <ng-container *ngIf="column.headerDisabled"
                                      (click)="column.headerDisabled = !column.headerDisabled"
                                      class="title-view">
                            <nb-icon *ngIf="column.icon" [icon]="column.icon"></nb-icon>
                            <span [nbTooltip]="column.header"
                                  [nbTooltipDisabled]="column.header.length <= 12">{{ column.header }}</span>
                        </ng-container>
                    </div>

                    <div class="column-title__meta">
                        <small *ngIf="column.headerDisabled && column.tasks.length > 0">{{ column.tasks.length }}</small>

                        <button nbButton ghost *ngIf="column.tasks.length==0 && column.columnType==null" size="small"
                                class="column-remove-link"
                                [nbPopover]="columnRemoveConfirm"
                                [nbPopoverContext]="{columnId: column.id}"
                                nbTooltip="Удалить колонку?">
                            <nb-icon icon="trash-2-outline"></nb-icon>
                        </button>
                        <button nbButton
                                ghost
                                *ngIf="column.columnType==null"
                                size="small"
                                class="column-remove-link"
                                (click)="column.headerDisabled = !column.headerDisabled"
                                nbTooltip="Переименовать колонку?">
                            <nb-icon icon="edit-outline"></nb-icon>
                        </button>
                    </div>
                </div>
                <div class="column-color-stripe" [style.background-color]="column.color || getColumnColor(column)"></div>
                <div class="tasks-container"
                   id="{{column.id}}"
                   [cdkDropListConnectedTo]="syncColumn"
                   cdkDropList
                   [cdkDropListData]="column.tasks"
                   (cdkDropListDropped)="drop($event)">

                <ng-container *ngFor="let item of column.tasks">
                  <div class="task" *ngIf="!item.hidden" cdkDrag [cdkDragData]="item" (click)="openIssueModal(item.iid, item.projectAlias, $event)" [class.my]="item.assignee?.id == storeService.getCustomer()?.id" [class.no-a]="!item.assignee">
                    <div class="tags">
                      <a *ngIf="isParentAnEpic(item.parent)" class="epic-link" [routerLink]="[]" (click)="openIssueModal(item.parent.iid, item.parent.alias, $event)">{{ item.parent.epicName }}</a>
                    </div>

                    <div class="task-alias">
                      <app-issue-tag [issue]="item" [short]="true"></app-issue-tag>

                      <nb-icon *ngIf="item.hiddenForClients" class="hiddenForClients" icon="eye-off-outline" nbTooltip="Задача скрыта для клиента"></nb-icon>

                      <nb-icon *ngIf="item.issueType?.icon" [icon]="item.issueType.icon" pack="jira" [nbTooltip]="item.issueType.header"></nb-icon>

                      {{ item.projectAlias }}-{{ item.iid }}
                    </div>
                    <div class="task-header">{{ item.header }}</div>
                    <div class="tags" *ngIf="!!item.environmentList">
                      <tui-chip appearance="info" *ngFor="let env of item.environmentList" (click)="setEnvironment(env, $event)">{{ env }}</tui-chip>
                    </div>
                    <div class="task-footer">
                      <div class="task-assignee hide-for-client-role">
                          <nb-user
                                  *ngIf="item.assignee"
                                  [nbTooltip]="item.assignee?.name"
                                  size="small"
                                  [showInitials]="!item.assignee?.avatar"
                                  [showName]="false"
                                  [name]="getAssigneeName(item)"
                                  [picture]="getImageUri( item.assignee?.avatar)"
                          >
                          </nb-user>
                      </div>
                      <div class="estimate " *ngIf="item.estimateForClient">
                        <span class="fc" [nbTooltip]="(isClientRole() ? translations.estimateShort : translations.estimateForClient ) + ' - ' + showEstimateTime(item.estimateForClient)">{{ showEstimateTime(item.estimateForClient) }}</span>
                      </div>

                      <div class="estimate hide-for-client-role" *ngIf="item.estimate">
                        <span [nbTooltip]="translations.estimate + ' - ' + showEstimateTime(item.estimate)">{{ showEstimateTime(item.estimate) }}</span>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #columnRemoveConfirm let-data>
  <nb-card style="padding: 0 20px">
    <nb-card-header>Удалить Колонку?</nb-card-header>
    <nb-card-body style="margin-top: 20px">
      <button nbButton status="danger" size="small" (click)="removeColumn(data.columnId)">Удалить</button>&nbsp;&nbsp;
      <button nbButton ghost status="basic" size="small" (click)="closeColumnRemoveConfirm()">Отмена</button>
    </nb-card-body>
  </nb-card>
</ng-template>
